import axios from 'axios';



const host = process.env.VUE_APP_API_URL; 
const install = (Vue, vm) => {
    function request(url, params, headers, method,reply=0) {    
        
        let oHeader={
            UserId:headers.UserId,
            AccessToken:headers.AccessToken||headers.token,
            Platform:headers.Platform,
        }
        if(headers["Time-zone"])oHeader["Time-zone"]=headers["Time-zone"]
        return new Promise((resolve, reject) => {
            axios({
                baseURL: host,
                url: url,
                method: method,
                data: method === 'POST' ? params : null,
                params: method === 'GET' ? params : null,
                headers: oHeader,
            }).then(res => {
                // console.log(res)
                // console.log(11111,process.env)
                // debugger
                if (res.status == 200) {      
                    if(res.data.code=="-200"||res.data.code=="-50"){
                        if(reply>=2){
                            alert("Network Error!");
                            return false;
                        }
                        // console.log("request -200")
                        refresh(url, params, headers, method,reply).then(res=>{
                            resolve(res)
                         })
                    }else if(res.data.code == 1){
                        resolve(res.data)
                    }else if(res.data.code == "-201"){
                        if(reply>=2){
                            alert("Network Error!");
                            return false;
                        }  
                        localStorage.removeItem("randomToken");
                        localStorage.removeItem("randomUserId");                            
                        localStorage.removeItem("AccessToken");       
                        localStorage.removeItem("UserId")
                        // console.log(oHeader)
                        getDefHeaders(oHeader).then(res=>{
                            // console.log(res)
                             request(url, params, res, method,++reply).then(res=>{
                                // console.log(res)
                                resolve(res)
                             })
                        })
           
                        // reject(res.data)
                    }else{
                        // console.log(res.data)
                        resolve(res.data)
                    }
                    
                } else {
                    // console.log(res.data)
                    reject(res.data)

                }
            }, err => {
                alert("Network Error!")
                reject(err)
            })
        })
    }
    function getDefHeaders(headers) {
        return new Promise((resolve,reject)=>{      
        ///返回默认头
            let obj={};
            // console.log(headers)
            if(headers&&headers["Time-zone"])obj["Time-zone"]=headers["Time-zone"];
            
            obj.UserId=localStorage.getItem("UserId");
            obj.AccessToken=localStorage.getItem("AccessToken");
            // debugger
            if(obj.UserId&&obj.AccessToken){
                resolve({
                    UserId:obj.UserId,
                    Platform: 'web',
                    AccessToken:obj.AccessToken,
                })
                // alert("有AccessToken")
                // console.log("登录过")
            }else{
                // console.log("随机数登录")
                obj.randomNumber=localStorage.getItem("randomNumber");
                obj.randomUserId=localStorage.getItem("randomUserId");
                obj.randomToken=localStorage.getItem("randomToken");    

                // console.log(222222,obj)
                if(!obj.randomUserId||!obj.randomToken){
                    getRandomInfo().then(res=>{
                        // console.log(res)
                        resolve({
                            UserId:res.userId,
                            Platform: 'web',
                            token:res.AccessToken,
                            randomNumber:res.randomNumber
                        })
                    })
                    // alert("啥都没");
                }else{
                    // alert("有随机数");
                    resolve({
                        UserId:obj.randomUserId,
                        Platform: 'web',
                        AccessToken:obj.randomToken,     
                        randomNumber:obj.randomNumber             
                    })
                }
            }
            
        })
    }
    function getRandomInfo(num=0){        
        return new Promise((resolve,reject)=>{
            let randomNumber=localStorage.getItem("randomNumber")||Math.random();
            axios({
                baseURL: host,
                url: "h5/loginbydev?dev="+randomNumber,
                method: "GET",   
                headers: { Platform:"web" },    
            }).then(res=>{
                if (res.status == 200) {
                    if(res.data.code==1){
                        // console.log(res.data)
                        localStorage.setItem("randomNumber",randomNumber);
                        localStorage.setItem("randomUserId",res.data.userId);
                        localStorage.setItem("randomToken",res.data.token);
                        resolve({AccessToken:res.data.token,userId:res.data.userId,randomNumber})
                    }else{
                        if(num<2)getRandomInfo(++num);
                        
                    }
                }else{
                    if(num<2)getRandomInfo(++num);
                }
                
            }, err => {
                if(num<2)getRandomInfo(++num);
            })
        })
        
    }
    /* *
     * get
     */
    function get(url, params, headers) {
        // console.log(vm)
        return  getDefHeaders().then(res=>{
            if(headers)Object.assign( res, headers);
            return  request(url, params, res, "GET")
        })
        
    }

    /**
     * post
     */
    function post(url, params, headers) {
        return getDefHeaders().then(res=>{
            if(headers)Object.assign( res, headers);
            // console.log(res)
            return request(url, params, res, "POST")
        })
        
    }
    function refresh(url, params, headers, method,reply){
        return new Promise((resolve,reject)=>{        
        let oHeaders=JSON.parse(JSON.stringify(headers));
        if(oHeaders.randomNumber){delete oHeaders.randomNumber};
        let at=localStorage.getItem("AccessToken");
        let rt=localStorage.getItem("randomToken");
        let whichtoken=""
        
        if(at==oHeaders.AccessToken){
            whichtoken=1;
        }else{
            whichtoken=2; 
        }
        //whichtoken  1是登录token  2是随机token
            axios({
                baseURL:host,
                url: "token/reflush",        
                headers: oHeaders,
            }).then(res => {
                // console.log(res)
                if (res.status == 200&&res.data.code=="1") {
                    headers.AccessToken=res.data.token;
                    if(whichtoken==1){
                        localStorage.setItem("AccessToken",res.data.token)
                    }else{
                        localStorage.setItem("randomToken",res.data.token)
                    }
                    
                    request(url, params, headers, method,++reply).then(res=>{
                        resolve(res)
                    })
                }
            }, err => {
                // console.log(err)
                reject(err)
            })
        })
    }
    Vue.prototype.$http = {
        Get: get,
        Post: post,
    }
}

export default {
    install
}
